"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = IntentForm;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _index = _interopRequireDefault(require("../headline-lockup/index.js"));
var _siblingSet = _interopRequireDefault(require("@ux/sibling-set"));
var _selectItem = _interopRequireDefault(require("../../buttons/select-item"));
var _merchButton = require("@site/pattern-library-core/merch-button");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Wrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Wrapper",
  class: "pl-wjt1px1"
});
const getItemId = (sectionId, itemId) => `${sectionId}_${itemId}`;
function IntentForm({
  sections = [],
  onSubmit,
  submitText,
  submitEid
}) {
  const [selectedItems, setSelectedItems] = (0, _react.useState)([]);
  const isFormEnabled = () => {
    return sections?.every((section, sectionIndex) => {
      const sectionItems = section.items?.map((item, itemIndex) => getItemId(sectionIndex, itemIndex));
      return selectedItems.some(item => sectionItems.includes(item));
    });
  };
  const onSelect = (itemId, isSelected) => {
    if (isSelected && !selectedItems.includes(itemId)) {
      setSelectedItems([...selectedItems, itemId]);
    } else if (!isSelected) {
      setSelectedItems(selectedItems?.filter(id => itemId !== id));
    }
  };
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    "data-cy": 'intent-form'
  }, sections?.map(({
    heading,
    description,
    items,
    type
  }, sectionIndex) => /*#__PURE__*/_react.default.createElement(_section.default, {
    key: sectionIndex,
    padding: "none",
    dataCy: "intent-form-section"
  }, /*#__PURE__*/_react.default.createElement(_index.default, {
    headlineLineLength: 2.5,
    headlineTag: "h2",
    headlineSize: "h2",
    heading: heading,
    description: description,
    textAlign: "start"
  }), /*#__PURE__*/_react.default.createElement(_siblingSet.default, {
    wrap: true,
    gap: 'md'
  }, items?.map(({
    icon,
    text,
    eid
  }, itemIndex) => {
    const itemId = getItemId(sectionIndex, itemIndex);
    return /*#__PURE__*/_react.default.createElement(_selectItem.default, {
      id: itemId,
      key: icon,
      icon: icon,
      text: text,
      type: type,
      eid: eid,
      onSelect: onSelect,
      selected: selectedItems.includes(itemId)
    });
  })))), /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButton, {
    type: 'submit',
    text: submitText,
    "data-eid": submitEid,
    "data-cy": "intent-form-submit",
    onClick: onSubmit,
    disabled: !isFormEnabled()
  }));
}
IntentForm.propTypes = {
  sections: _propTypes.default.arrayOf(_propTypes.default.shape({
    type: _propTypes.default.oneOf(['small', 'large']),
    items: _propTypes.default.arrayOf(_propTypes.default.shape({
      eid: _propTypes.default.string,
      icon: _propTypes.default.string,
      text: _propTypes.default.string
    })),
    heading: _propTypes.default.string,
    description: _propTypes.default.string
  })),
  onSubmit: _propTypes.default.func,
  submitText: _propTypes.default.string,
  submitEid: _propTypes.default.string
};